// src/pages/usa/SouthDakota.js
import "../../App.css";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BackOnly from "../../components/BackOnly";
import ContactPopup from "../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../components/affiliate/AffiliateBooking";   // ⭐ REQUIRED
import AffiliateExpedia from "../../components/affiliate/AffiliateExpedia";   // ⭐ REQUIRED
import AffiliateTrip from "../../components/affiliate/AffiliateTrip";   // ⭐ REQUIRED

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: South Dakota ALWAYS goes back to USA map
export const backRoute = "/map/usa";

export default function SouthDakota() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly
  useEffect(() => {
    navigate(".", { state: { backRoute } });
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>South Dakota</h1>

        <section className="travel-review">
          {/* LEFT COLUMN */}
          <div className="travel-text">
            <h2>🏞️ Discover South Dakota</h2>

            <p>
              South Dakota sits in the north-central United States, bordered by North
              Dakota, Nebraska, Minnesota, Iowa, Wyoming, and Montana. Its landscape
              transitions from gently rolling plains in the east to dramatic canyons and
              granite peaks in the west. Elevation ranges from around 900 feet near the
              eastern border to 7,242 feet at Black Elk Peak in the Black Hills, the
              highest point in the state.
            </p>

            <p>
              With an average elevation of roughly 2,352 feet, South Dakota offers a
              diverse terrain ideal for hiking, scenic drives, and outdoor photography.
              From the surreal formations of Badlands National Park to the forested slopes
              of Custer State Park, the state blends geological wonder with wide‑open
              serenity.
            </p>

            <h3>🚗 Getting There</h3>

            <p>
              Most travelers heading into South Dakota fly into Sioux Falls Regional
              Airport (FSD) or Rapid City Regional Airport (RAP), depending on whether
              they’re exploring the eastern plains or the western Black Hills. The state
              is well‑connected by I‑90, which runs east‑west across South Dakota and
              serves as the main highway for cross‑state travel. Whether you’re driving in
              from Minnesota or Wyoming, I‑90 offers direct access to major destinations
              like Badlands National Park, Mount Rushmore, and Custer State Park.
            </p>

            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Mount Rushmore:</strong> One of the most iconic landmarks in the
                  United States, featuring the 60‑foot‑tall granite faces of four U.S.
                  presidents. The site includes a visitor center, walking trails, and
                  evening lighting ceremonies during summer.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=43.87636332491358,-103.45492559423315"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Custer State Park:</strong> A beautiful park full of scenic
                  stops, photo opportunities, and peaceful nature. Sylvan Lake is a
                  highlight, especially in fall.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Black Elk Peak:</strong> The highest point in South Dakota,
                  offering unforgettable views from its stone watchtower.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=43.86600604805363,-103.53112532282705"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Sylvan Lake:</strong> A calm, scenic lake surrounded by rock
                  formations — perfect for walking, photography, and relaxing.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=43.844334813564295,-103.56278571990522"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Needles Eye Tunnel:</strong> A narrow rock tunnel where only one
                  car fits — a unique and memorable experience.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=43.84148011662462,-103.54495130046075"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Cosmos Mystery Area:</strong> A quirky attraction where physics
                  seems to bend — balls roll uphill, and balance feels distorted.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=43.924199320993445,-103.42168605538905"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>
            </ul>

            <h3>🪨 Hidden Gems in South Dakota</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Stronghold & Palmer Creek Districts (Badlands):</strong> Remote,
                  rugged, and far less visited than the main park areas.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=43.85525743244762, -102.33950245643273"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Sage Creek Wilderness Area:</strong> Rolling prairie, bison
                  herds, and peaceful solitude.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=43.89405799286811, -102.41365187549275"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

          

              <li>
                <div className="place-block">
                  <strong>Crazy Horse Memorial:</strong> A massive mountain carving honoring
                  the Lakota leader Crazy Horse.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=43.83672941309025, -103.62236628730041"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>

             

              <li>
                <div className="place-block">
                  <strong>Jewel Cave National Monument:</strong> One of the longest cave
                  systems in the world.
                  <br />
                  <a
                    href="https://www.google.com/maps?q=43.731112532526836, -103.82991876712308"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 View on Google Maps
                  </a>
                </div>
              </li>
            </ul>

            <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                        <div className="affiliate-block">
                          <AffiliateExpedia />
                          <AffiliateBooking />
                          <AffiliateTrip />
                        </div>

            <h3>🎥 My Travel Videos</h3>

            <p>Here are some videos from Black Elk Peak and Sylvan Lake.</p>

            <p>
              <a
                href="https://youtu.be/k4iGWPwe-ts?si=8toy9P6sR21nwt3T"
                target="_blank"
                rel="noopener noreferrer"
              >
                Black Elk Peak
              </a>
            </p>

            <p>
              <a
                href="https://youtu.be/bQoPHoGxro0?si=1R4RtttKtlzQccQs"
                target="_blank"
                rel="noopener noreferrer"
              >
                Sylvan Lake
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/bQoPHoGxro0?si=1R4RtttKtlzQccQs"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/southdakota/sylvan.jpg"
                alt="Sylvan Lake video"
              />
            </a>

            <a
              href="https://youtu.be/k4iGWPwe-ts?si=8toy9P6sR21nwt3T"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/southdakota/hp.jpg"
                alt="Black Elk Peak video"
              />
            </a>

            <img src="/images/usa/southdakota/cosmos2.jpg" alt="Cosmos Mystery Area" />
            <img src="/images/usa/southdakota/cosmos.jpg" alt="Cosmos Mystery Area Balance" />
            <img src="/images/usa/southdakota/cosmosmystery.jpg" alt="Cosmos Mystery" />
            <img src="/images/usa/southdakota/sylvanlakeaerealview.jpg" alt="Sylvan Lake" />
            <img src="/images/usa/southdakota/blackelkpeak.jpg" alt="Black Elk Peak" />
            <img src="/images/usa/southdakota/blackelk.jpg" alt="Black Elk Aereal View" />
            <img src="/images/usa/southdakota/mtrushmore.jpg" alt="Mount Rushmore" />
            <img src="/images/usa/southdakota/needlestunnel.jpg" alt="Needles Eye Tunnel" />
            <img src="/images/usa/southdakota/tunnel.jpg" alt="The Tunnel in Sylvan Lake" />
            <img src="/images/usa/southdakota/mtrushmore.jpg" alt="Mount Rushmore" />
            <img src="/images/usa/southdakota/driving.jpg" alt="Driving in Mt Rushmore" />
            <img src="/images/usa/southdakota/syl1copy.jpg" alt="Sylvan Lake Rocks" />
            <img src="/images/usa/southdakota/thefaces.jpg" alt="Mt Rushmore Faces" />
          </div>
        </section>
      </div>

      {/* EMAIL BUTTON */}
      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      {/* POPUP */}
      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
